export const FETCH_VALUE_PENDING = 'FETCH_VALUE_PENDING';
export const FETCH_VALUE = 'FETCH_VALUE';

export const STORE_VALUE_PENDING = 'STORE_VALUE_PENDING';
export const STORE_VALUE = 'STORE_VALUE';
